import { ButtonType, ButtonTheme } from "./types";
import { ThemeInterface } from "../../theme/theme";

export const getSpinnerColor = (
  type: ButtonType,
  theme: ThemeInterface
): string => {
  if (type === "text") return theme.button.text.color;
  if (type === "white") return "#fff";
  const { color, hollow } = theme.button[type];
  return hollow ? color : "white";
};

export const getThemeValues = (
  type: ButtonType,
  theme: ThemeInterface
): ButtonTheme => {
  if (type === "text")
    return {
      color: theme.button.text.color,
      hollow: false,
      solidOnHover: false,
    };
  if (type === "white")
    return {
      color: "#fff",
      hollow: true,
      solidOnHover: false,
    };
  const { color, textColor, hollow, solidOnHover } = theme.button[type];
  return { color, textColor, hollow: !!hollow, solidOnHover: !!solidOnHover };
};
